import { render, staticRenderFns } from "./MetamaskWrongNetwork.vue?vue&type=template&id=32d015ea&scoped=true&"
import script from "./MetamaskWrongNetwork.vue?vue&type=script&lang=js&"
export * from "./MetamaskWrongNetwork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d015ea",
  null
  
)

export default component.exports